// Classes
export const INSTRUCTION_CARD_CLASS = 'instruction-card';
export const CONTENT_CONTAINER_CLASS = `${INSTRUCTION_CARD_CLASS}__container`;
export const CONTENT_CLASS = `${INSTRUCTION_CARD_CLASS}__content`;
export const FOOTER_CLASS =`${INSTRUCTION_CARD_CLASS}__footer`;
export const CONTENT_DETAIL_CLASS = `${INSTRUCTION_CARD_CLASS}__content-detail`;
export const CONTENT_ICON_CLASS = `${INSTRUCTION_CARD_CLASS}__content-content-icon`;
export const CONTENT_ICON = `${INSTRUCTION_CARD_CLASS}__content-content-icon--instruction`;
export const CONTENT_TEXT_CLASS = `${CONTENT_DETAIL_CLASS}-content-text`;
export const INSTRUCTION_ICON_SWIPE_CLASS = `${INSTRUCTION_CARD_CLASS}__swiper-icon`;
export const INSTRUCTION_SWIPE_CLASS = `swiper-wrapper ${INSTRUCTION_CARD_CLASS}`;
export const INSTRUCTION_SWIPE_CONTENT_CLASS = `swiper-wrapper ${CONTENT_CLASS}`;
export const CONTENT_TITLE_CLASS = `${CONTENT_DETAIL_CLASS}-content-title`;


//DISMISS BUTTON
export const DISMISS_BUTTON_CLASS = 'instruction-card-dismiss-button';
export const I18_PREFIX = 'instruction_cards';
export const I18_DISMISS = `${I18_PREFIX}.dismiss`;
export const GTM_DISMISS_INSTRUCTION = 'instruction-dismiss';

// BetSlip instruction card
export const BETSLIP_INSTRUCTION_CARD_CLASS = 'betSlip-instruction-card';
export const BETSLIP_INSTRUCTION_CARD_CONTENT_CLASS = `${BETSLIP_INSTRUCTION_CARD_CLASS}__content`;
export const BETSLIP_INSTRUCTION_CARD_FOOTER_CLASS = `${BETSLIP_INSTRUCTION_CARD_CLASS}__footer`;
export const BETSLIP_INSTRUCTION_CARD_CONTAINER_CLASS = `${BETSLIP_INSTRUCTION_CARD_CONTENT_CLASS}--container`;
export const BETSLIP_INSTRUCTION_CARD_CONTAINER_TEXT_CLASS = `${BETSLIP_INSTRUCTION_CARD_CONTENT_CLASS}__text`;
export const BETSLIP_INSTRUCTION_CARD_BUTON_CONTAINER_CLASS = `${BETSLIP_INSTRUCTION_CARD_CONTENT_CLASS}--buttonContainer`;
export const BETSLIP_INSTRUCTION_CARD_BUTON_CLASS = `${BETSLIP_INSTRUCTION_CARD_BUTON_CONTAINER_CLASS}__button`;
export const I18_VIEW_OPEN_BETS = `${I18_PREFIX}.view_open_bets_here`;
export const I18_CASHOUT = `${I18_PREFIX}.cash_out_available`;
export const I18_EVENT_SCOREBOARDS = `${I18_PREFIX}.view_event_scoreboards`;

//INSTRUCTION CARD
export const ZERO = 0;
export const SPECIALS_INSTRUCTION_CARD = 'specials';
export const BETFEED_INSTRUCTION_CARD = 'betfeed';
export const BETFEED_SWIPER_CLASS = 'swiper-slide';
export const BETFEED_SWIPER_DISMISS_CLASS = 'fadeout';
export const DISMISS_URL = '/instruction_cards/dismiss/';
